import { calendarDay } from './loanEstimate'
import type { LoanInstallment } from './ledger'

export function monthlyInstallments(principalCents: number, count: number, firstDue: string): LoanInstallment[] | null {
  const anchor = calendarDay(firstDue)
  if (!anchor || !Number.isSafeInteger(principalCents) || !Number.isInteger(count) || count < 1 || count > 120 || principalCents < count) return null
  const base = Math.floor(principalCents / count)
  return Array.from({ length: count }, (_, index) => {
    const first = new Date(Date.UTC(anchor.getUTCFullYear(), anchor.getUTCMonth() + index, 1))
    const last = new Date(Date.UTC(first.getUTCFullYear(), first.getUTCMonth() + 1, 0)).getUTCDate()
    first.setUTCDate(Math.min(anchor.getUTCDate(), last))
    return { dueAt: `${first.toISOString().slice(0, 10)}T23:59:59.000Z`, principalCents: base + (index === count - 1 ? principalCents % count : 0) }
  })
}
